import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      login(res.data.token, res.data.user);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 bg-[#F3ECDD]">
      <div className="w-full max-w-md bg-[#FFFFFF] border border-[#DAD0BA] rounded-3xl p-10 shadow-[0_12px_40px_rgba(60,55,40,0.08)]">
        <div className="flex items-center gap-2 justify-center mb-8">
          <span className="font-serif text-2xl text-[#33311F]">InAlign Admin</span>
        </div>
        <h1 className="font-serif text-3xl font-light text-[#33311F] text-center mb-8">Welcome back</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" placeholder="admin@wellness.com" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-[#C0714A]">{error}</p>}
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-[#556B2F] hover:bg-[#44531F] disabled:opacity-50 text-white rounded-full py-3 transition-colors flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
